if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    quantityInput = undefined;
    quantityForm = undefined;
    onVariantChangeUnsubscriber = undefined;
    cartUpdateUnsubscriber = undefined;
    abortController = undefined;
    pendingRequestUrl = null;

    constructor() {
      super();
      this.quantityInput = this.querySelector('.quantity__input');
    }

    connectedCallback() {
      this.initializeProductSwapUtility();

      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );

      this.initQuantityHandlers();
    }

    initQuantityHandlers() {
      if (!this.quantityInput) return;

      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;

      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber();
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    initializeProductSwapUtility() {
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      const isMainVariant = this.contains(event.target);
      const stickyVariantPicker = document.querySelector(`#variant-radios-${this.dataset.section}-sticky, #variant-selects-${this.dataset.section}-sticky`);
      const isStickyVariant = stickyVariantPicker && stickyVariantPicker.contains(event.target);

      if (!isMainVariant && !isStickyVariant) return;

      this.resetProductFormState();
      this.syncVariantPickers(target);

      let optionValuesToUse = selectedOptionValues;
      if (isStickyVariant && !isMainVariant) {
        const mainVariantPicker = this.querySelector('variant-radios, variant-selects');
        if (mainVariantPicker) {
          optionValuesToUse = Array.from(mainVariantPicker.querySelectorAll('select option[selected], fieldset input:checked')).map(
            ({ dataset }) => dataset.optionValueId
          );
        }
      }

      const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.dataset.url !== productUrl;
      const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, optionValuesToUse, shouldFetchFullPage),
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
          : this.handleUpdateProductInfo(productUrl),
      });
    }

    syncVariantPickers(changedInput) {
      const mainVariantPicker = document.querySelector(`#variant-radios-${this.dataset.section}, #variant-selects-${this.dataset.section}`);
      const stickyVariantPicker = document.querySelector(`#variant-radios-${this.dataset.section}-sticky, #variant-selects-${this.dataset.section}-sticky`);

      if (!mainVariantPicker || !stickyVariantPicker) return;

      const isMainChanged = mainVariantPicker.contains(changedInput);
      const sourcePicker = isMainChanged ? mainVariantPicker : stickyVariantPicker;
      const targetPicker = isMainChanged ? stickyVariantPicker : mainVariantPicker;

      const sourceInputs = sourcePicker.querySelectorAll('input[type="radio"]:checked, select');

      sourceInputs.forEach((sourceInput) => {
        let targetInput;

        if (sourceInput.tagName === 'SELECT') {
          const selectName = sourceInput.getAttribute('name');
          let targetSelectName = selectName;

          if (isMainChanged) {
            targetSelectName = 'sticky-' + selectName;
          } else {
            targetSelectName = selectName.replace('sticky-', '');
          }

          targetInput = targetPicker.querySelector(`select[name="${targetSelectName}"]`);

          if (targetInput) {
            targetInput.value = sourceInput.value;
            Array.from(targetInput.options).forEach(opt => opt.removeAttribute('selected'));
            if (targetInput.selectedOptions[0]) {
              targetInput.selectedOptions[0].setAttribute('selected', 'selected');
            }
          }
        } else if (sourceInput.type === 'radio') {
          const radioName = sourceInput.getAttribute('name');
          const radioValue = sourceInput.value;
          let targetRadioName = radioName;

          if (isMainChanged) {
            targetRadioName = 'sticky-' + radioName;
          } else {
            targetRadioName = radioName.replace('sticky-', '');
          }

          targetInput = targetPicker.querySelector(`input[type="radio"][name="${targetRadioName}"][value="${radioValue}"]`);

          if (targetInput) {
            targetInput.checked = true;

            const optionIndex = radioName.replace('sticky-', '').split('-').pop();
            const selectedValueDisplay = targetPicker.querySelector(`.selected__value[data-option-index="${optionIndex}"]`);
            if (selectedValueDisplay) {
              selectedValueDisplay.textContent = `(${radioValue})`;
            }
          }
        }
      });
    }

    resetProductFormState() {
      const productForm = this.productForm;
      if (productForm) {
        const addButton = productForm.querySelector('[name="add"]');
        if (addButton) {
          addButton.removeAttribute('disabled');
        }
        if (productForm.handleErrorMessage) {
          productForm.handleErrorMessage();
        }
      }
    }

    handleSwapProduct(productUrl, updateFullPage) {
      return (html) => {
        const variant = this.getSelectedVariant(html.querySelector('product-info'));
        this.updateURL(productUrl, variant?.id);
        console.log(updateFullPage);
        if (updateFullPage) {
          document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
          const mainContent = document.querySelector('main');
          if (mainContent) {
            mainContent.innerHTML = html.querySelector('main').innerHTML;
          }
        } else {
          const newProductInfo = html.querySelector('product-info');
          if (newProductInfo) {
            this.innerHTML = newProductInfo.innerHTML;
            this.dataset.url = productUrl;
          }

          const newMediaWrapper = html.querySelector('.product__media-wrapper');
          const currentMediaWrapper = document.querySelector('.product__media-wrapper');
          if (newMediaWrapper && currentMediaWrapper) {
            currentMediaWrapper.innerHTML = newMediaWrapper.innerHTML;
          }

          const newMediaGallery = html.querySelector('.product__media-gallery');
          const currentMediaGallery = document.querySelector('.product__media-gallery');
          if (newMediaGallery && currentMediaGallery) {
            currentMediaGallery.innerHTML = newMediaGallery.innerHTML;
          }

          this.updateVariantInputs(variant?.id);

          const updateSourceFromDestination = (id) => {
            const sourceId = `${id}-${this.sectionId}`;
            const source = html.getElementById(sourceId);
            const destination = document.getElementById(sourceId);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList = source.classList;
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Inventory');
          updateSourceFromDestination('Sku');

          const productForm = document.getElementById(`product-form-${this.dataset.section}`);
          if (productForm) {
            const sourceForm = html.getElementById(`product-form-${this.sectionId}`);
            if (sourceForm) {
              const addButton = productForm.querySelector('[name="add"]');
              const sourceButton = sourceForm.querySelector('[name="add"]');
              if (addButton && sourceButton) {
                if (sourceButton.hasAttribute('disabled')) {
                  addButton.setAttribute('disabled', 'disabled');
                } else {
                  addButton.removeAttribute('disabled');
                }
                const addButtonText = addButton.querySelector('span');
                const sourceButtonText = sourceButton.querySelector('span');
                if (addButtonText && sourceButtonText) {
                  addButtonText.textContent = sourceButtonText.textContent;
                }
              }
            }
          }
        }
      };
    }

    renderProductInfo({ requestUrl, callback }) {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          callback(html);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            return;
          }
          console.error(error);
        });
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariantScript = productInfoNode?.querySelector('variant-selects [data-selected-variant], variant-radios [data-selected-variant]');
      if (!selectedVariantScript) return null;

      try {
        return JSON.parse(selectedVariantScript.innerHTML);
      } catch (e) {
        return null;
      }
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];

      if (!shouldFetchFullPage) {
        params.push(`section_id=${this.sectionId}`);
      }

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url}?${params.join('&')}`;
    }

    handleUpdateProductInfo(productUrl) {
      return (html) => {
        const variant = this.getSelectedVariant(html);
        const pickupAvailability = this.querySelector('pickup-availability');
        if (pickupAvailability && typeof pickupAvailability.update === 'function') {
          pickupAvailability.update(variant);
        }

        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);

        if (!variant) {
          this.setUnavailable();
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant: null,
            },
          });
          return;
        }
        this.updateMedia(html, variant?.featured_media?.id);

        const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
          const sourceId = `${id}-${this.sectionId}`;
          const destId = `${id}-${this.dataset.section}`;
          const source = html.getElementById(sourceId);

          let destination = this.querySelector(`#${destId}`);
          if (!destination) {
            destination = document.querySelector(`#${destId}`);
          }

          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('hidden', shouldHide(source));
          }

          const stickySourceId = `${id}-${this.sectionId}-sticky`;
          const stickyDestId = `${id}-${this.dataset.section}-sticky`;
          const stickySource = html.getElementById(stickySourceId);
          const stickyDest = document.querySelector(`#${stickyDestId}`);

          if (stickySource && stickyDest) {
            stickyDest.innerHTML = stickySource.innerHTML;
            stickyDest.classList.toggle('hidden', shouldHide(stickySource));
          }
        };

        updateSourceFromDestination('price');
        updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
        updateSourceFromDestination('Main-Sku', ({ classList }) => classList.contains('hidden'));
        updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');

        this.updateQuantityRules(this.sectionId, html);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant,
          },
        });
      };
    }

    updateVariantInputs(variantId) {
      const selectors = `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`;
      document.querySelectorAll(selectors).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId || '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updateURL(url, variantId) {
      const shareButton = this.querySelector('share-button');
      if (shareButton && shareButton.updateUrl) {
        shareButton.updateUrl(`${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }

    setUnavailable() {
      const selectors = ['price', 'Inventory', 'Sku', 'Main-sku'];
      selectors.forEach((id) => {
        const element = this.querySelector(`#${id}-${this.dataset.section}`);
        if (element) {
          element.classList.add('visibility-hidden');
        }
      });
    }

    updateMedia(html, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;

      const mediaGallery = document.querySelector(`#MediaGallery-${this.dataset.section}`);

      if (mediaGallery && mediaGallery.setActiveMedia) {
        const mediaId = `${this.dataset.section}-${variantFeaturedMediaId}`;
        mediaGallery.setActiveMedia(mediaId, true);
      }

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
      if (modalContent && newModalContent) {
        modalContent.innerHTML = newModalContent.innerHTML;
      }
    }

    setQuantityBoundries() {
      if (!this.quantityInput) return;

      const data = {
        cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
        min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
        max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
        step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.quantityInput.min = min;
      if (max) {
        this.quantityInput.max = max;
      } else {
        this.quantityInput.removeAttribute('max');
      }
      this.quantityInput.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    fetchQuantityRules() {
      const currentVariantInput = this.productForm?.querySelector('input[name="id"]');
      if (!currentVariantInput || !currentVariantInput.value) return;

      const loadingSpinner = this.quantityForm?.querySelector('.quantity__rules-cart .loading-overlay');
      if (loadingSpinner) {
        loadingSpinner.classList.remove('hidden');
      }

      fetch(`${this.dataset.url}?variant=${currentVariantInput.value}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          }
        });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      if (!quantityFormUpdated || !this.quantityForm) return;

      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            else current.removeAttribute(attribute);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }

    get productForm() {
      return this.querySelector(`product-form`);
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.section;
    }
  }
)};